// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useState } from 'react'
import moment from 'moment-timezone'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { Calendar, SecondaryButton, SvgIcon, useOutsideClick } from 'ui_kit_qmd'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import './VisitsDateFilter.scss'
import { CLEAR_TEXT } from '../../../utils/constants'
import { initialState } from '../VisitsReducer'
import { parseTimeZone } from '../../../utils/common'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const formatDateToShow = (date) => moment(date).format('dddd MMM DD YYYY')

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getFormattedDate = (date, startOrEnd) =>
  moment(date).format(startOrEnd === 'start' ? 'YYYY-MM-DDT00:00:00.000Z' : 'YYYY-MM-DDT23:59:59.000Z')

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const isDateRangeValid = (fromDate, toDate) => {
  const diff = moment(toDate).diff(moment(fromDate), 'days')
  return diff < 30 && diff >= 0
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const VisitsDateFilter = ({ stateFilter, dispatchFilter, closeFilter, closeRemarks }) => {
  const ref = useOutsideClick(closeFilter)
  const [calendarMode, setCalendarMode] = useState('from')
  const [currentRange, setCurrentRange] = useState(stateFilter.date)

  const [dateValue, setDateValue] = useState(moment(stateFilter.date.fromDate).format('YYYY-MM-DDT00:00:00.000'))
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const profile = useSelector((state) => state.waitingRoomReducer.providerProfile)
  const timeZone = parseTimeZone(profile.TimeZone)
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onDateSelect = (value) => {
    const momentDate = moment.parseZone(moment(value).tz(timeZone, false).format())

    const hours = momentDate.hours()
    const minutes = momentDate.minutes()
    const seconds = momentDate.seconds()

    const isTimeGreaterThanZero = hours > 0 || minutes > 0 || seconds > 0
    if (isTimeGreaterThanZero) {
      momentDate.add(1, 'days')
    }

    if (calendarMode === 'from') {
      setCurrentRange({ fromDate: momentDate, toDate: momentDate })
      setCalendarMode('to')
      setDateValue(value)
    } else {
      setCurrentRange({ ...currentRange, toDate: momentDate })
      setDateValue(value)

      const fromDate = getFormattedDate(currentRange.fromDate, 'start')
      const toDate = getFormattedDate(momentDate, 'end')

      if (isDateRangeValid(fromDate, toDate)) {
        dispatchFilter({ type: 'date', payload: { fromDate, toDate, isDateUpdated: true } })
        closeFilter()
        closeRemarks()
      } else {
        const error = getUserFriendlyErrorMessage(errorCodes.CANNOT_SELECT_PERIOD_MORE_THAN_30_DAYS)
        dispatchFilter({ type: 'error', payload: error })
        setCalendarMode('from')
        setCurrentRange(stateFilter.date)
      }
    }
  }

  const resetData = () => {
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    const initialDate = initialState().date
    if (stateFilter.date.fromDate !== initialDate.fromDate || stateFilter.date.toDate !== initialDate.toDate) {
      dispatchFilter({ type: 'date', payload: initialDate })
    }
    closeFilter()
    closeRemarks()
  }

  const onStartDateClick = () => setCalendarMode('from')

  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  const tileDisabled = ({ date }) => {
    if (calendarMode === 'from') return false

    // Extract year, month, day from date
    const year = date.getFullYear()
    const month = date.getMonth() + 1 // 1-12
    const day = date.getDate()

    // Helper function to pad single digits with a leading zero
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const pad = (n) => (n < 10 ? `0${n}` : n)

    // Create 'YYYY-MM-DD' string for the selected date
    const selectedDateStr = `${year}-${pad(month)}-${pad(day)}`
    console.log(`tileDisabled - selectedDateStr: ${selectedDateStr}`)

    // Retrieve 'fromDateStr' from currentRange
    const fromDateStr = currentRange.fromDate
    console.log(`tileDisabled - fromDateStr: ${fromDateStr}`)

    return moment(selectedDateStr, 'YYYY-MM-DD').isBefore(moment(fromDateStr, 'YYYY-MM-DD'), 'day')
  }

  const fromDate = formatDateToShow(moment.tz(currentRange.fromDate, 'YYYY-MM-DD', timeZone))
  const toDate = formatDateToShow(moment.tz(currentRange.toDate, 'YYYY-MM-DD', timeZone))

  return (
    <section ref={ref} className='visits-date-filter'>
      <section className='visits-selected-date'>
        <div
          role='presentation'
          className={classNames('visits-selected-from', {
            'visits-date-selected': calendarMode === 'from',
          })}
          onClick={onStartDateClick}>
          <div className='visits-date-container'>
            <div className='visits-date-title'>Start date*</div>
            <div className='visits-date-value'>{fromDate}</div>
          </div>
          <div className='visits-date-icon'>
            <SvgIcon className='visits-calendar-icon' name='calendar' />
          </div>
        </div>
        <div
          className={classNames('visits-selected-to', {
            'visits-date-selected': calendarMode === 'to',
          })}>
          <div className='visits-date-container'>
            <div className='visits-date-title'>End date*</div>
            <div className='visits-date-value'>{toDate}</div>
          </div>
          <div className='visits-date-icon'>
            <SvgIcon className='visits-calendar-icon' name='calendar' />
          </div>
        </div>
      </section>
      <Calendar dateValue={dateValue} onDateSelect={onDateSelect} tileDisabled={tileDisabled} />
      <SecondaryButton btnText={CLEAR_TEXT} onPress={resetData} className='reset-visits-date-filter' />
    </section>
  )
}
